import "./MatchUrls.scss"
import { observer } from "mobx-react"
import React, { PureComponent } from "react"
import Select from "./Select"
import Icon from "../Icon"
import Button from "../Button"
import TextInput from "./TextInput"
import InputWrapper from "./InputWrapper"
import { MATCH_TYPES } from "../../app/constants"

const MatchUrl = ({ value, onChange, onRemove }) => {
  return (
    <div className="MatchUrl">
      <Select
        value={value.type}
        options={[
          { value: MATCH_TYPES.INCLUDES, label: "Includes" },
          { value: MATCH_TYPES.STARTS_WITH, label: "Starts with" },
          { value: MATCH_TYPES.EXACTLY, label: "Is exactly" },
        ]}
        onChange={type => onChange({ ...value, type })}
      />
      <TextInput
        value={value.url}
        onChange={url => onChange({ ...value, url })}
      />
      {onRemove && (
        <Button styleType="text" onClick={onRemove}>
          <Icon name="close" />
        </Button>
      )}
    </div>
  )
}

class MatchUrls extends PureComponent {
  get value() {
    return Array.isArray(this.props.value) ? this.props.value : []
  }

  handleChange = (match, index) => {
    let value = this.value
    value.splice(index, 1, match)
    this.props.onChange(value)
  }

  handleRemove = index => {
    let value = this.value
    value.splice(index, 1)
    this.props.onChange(value)
  }

  render() {
    return (
      <InputWrapper {...this.props}>
        {this.value
          .map((match, index) => (
            <MatchUrl
              key={index}
              value={match}
              onChange={v => this.handleChange(v, index)}
              onRemove={e => this.handleRemove(index)}
            />
          ))
          .concat(
            <MatchUrl
              value={{ type: MATCH_TYPES.INCLUDES, url: "" }}
              key={this.value.length}
              onChange={v => this.handleChange(v, this.value.length)}
            />
          )}
      </InputWrapper>
    )
  }
}

MatchUrls.displayName = "MatchUrls"

MatchUrls.defaultProps = {
  value: [],
}

export default observer(MatchUrls)



// WEBPACK FOOTER //
// ./src/lib/form/MatchUrls.js